import { Grid } from "@mui/material";
import ContentSection from "../../ContentSection";
import MxFormL3RushRadioDuoField from "@rf-l3/form/MxFormL3RushRadioDuo";
import useHasTrust from "../../hooks/useHasTrust";
import IsNo from "./IsNo";
import IsYes from "./IsYes";
import IsPending from "./Pending";
import { A_STATUS_TRUST } from "../../models/trust.const";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import useMediaQuery from "@/shared/hooks/use-media-query";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";

const Trust = () => {
  const {
    HAS_TRUST_YES: YES,
    HAS_TRUST_NO: NOT,
    HAS_TRUST_PENDING: PENDING
  } = useHasTrust();

  const {
    validationDocuments: { land_transfer_tax, trust, trust_transferred_title }
  } = useFormValidationsDocumentsMsgSlice();
  const { isMobile } = useMediaQuery();

  return (
    <Grid container item xs={12}>
      {!isMobile && (
        <Grid item maxWidth={500} minWidth={500} my={2}>
          <MxFormL3RushRadioDuoField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_has_trustee}
            items={A_STATUS_TRUST}
            label="¿Tiene fideicomiso?"
          />
        </Grid>
      )}
      {isMobile && (
        <Grid item maxWidth={500} minWidth={500} my={2}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_has_trustee}
            items={A_STATUS_TRUST}
            label="¿Tiene fideicomiso?"
          />
        </Grid>
      )}
      <ContentSection
        title="Fideicomiso"
        tooltip="FideoComiso"
        color="blue"
        alert={
          trust_transferred_title?.alert || trust?.alert || land_transfer_tax?.alert
        }
      >
        {YES && <IsYes />}
        {NOT && <IsNo />}
        {PENDING && <IsPending />}
      </ContentSection>
    </Grid>
  );
};

export default Trust;
